<template>
    <div style="position: relative">
        <v-btn
            color="primary"
            fab
            small
            dark
            bottom
            right
            absolute
            style="margin-bottom: 30px; margin-right: 70px"
            @click = "onMailToggle"
        >
            <v-icon>{{ showMailSlide ? 'mdi-close' : 'mdi-email-outline' }}  </v-icon>
        </v-btn>

        <d-inc-history
            v-if      = "incident"
            :incident = "incident"
            v-model   = "history"
        />

        <c-dms-viewer-card
            v-model   = "document.show"
            :document = "document.selected"
            @close    = "onCloseDocument"
            @assigned = "onAssigned"
        />

        <v-expand-x-transition>
            <v-card elevation="10" v-show="showMailSlide" class="dialog-border " style="position: absolute; width: 930px; height: 940px; right: 73px; top: 5px; z-index: 1">
                <div class="w-100 h-100 white">
                    <c-inc-mail-editor
                        :mail        = "mail"
                        :incident    = "incident"
                        :step        = "index"
                        :unit        = "unit"
                        :units       = "units"
                        @sended      = "onSended"
                    />

                </div>
            </v-card>
        </v-expand-x-transition>

        <c-app-content
            :sites           = "units"
            :search-on-focus = "false"
            @initialized     = "onInitialized"
        >
            <template v-slot:content>
                <div v-if="incident" style="display: flex; margin-top: 0" @keyup="onKeyup" >
                    <inc-side-menu
                        :sites           = "units"
                        :incident        = "incident"
                        :clipboard-entry = "clipboardEntry"
                        :index           = "index"
                        @history         = "onHistory"
                        @save            = "onSave"
                        @delete          = "onDelete"
                        @undelete        = "onUnDelete"
                        @refresh         = "onRefresh"
                        @email           = "onMail"
                        @typechanged     = "onChange"
                        @clipboard       = "onClipboard"
                        @clipboardremove = "onClipboardRemove"
                    />
                    <v-stepper
                        v-model   = "currentSequence"
                        @change   = "onStepChanged"
                        class     = "w-100"
                        :key      = "forceUpdate"
                        :outlined = "false"
                        non-linear
                    >
                        <!-- Previous incident button -->
                        <div
                            class="stepper-prev"
                            v-if="incident.prev"
                        >
                            <v-tooltip bottom >
                                <template v-slot:activator="{ on, attrs }">
                                    <a
                                        class  = "stepper-nav-btn"
                                        @click = "onGoto(incident.prev.id)"
                                        v-bind = "attrs"
                                        v-on   = "on"
                                    >
                                        <i class="fas fa-chevron-left primary--text"></i>
                                    </a>
                                </template>
                                <span>{{ incident.prev.name }}</span>
                            </v-tooltip>
                        </div>
                        <!-- Previous incident button -->

                        <div class="step-incident-id">ID {{ incident.id }}</div>
                        <v-stepper-header class="inc-stepper">
                            <template v-for="(data, index) in incident.data">
                                <v-stepper-step
                                    :key      = "index + '-step'"
                                    :step     = "data.sequence"
                                    :editable = "data.sequence <= maxValid"
                                    v-show    = "data.visible===true"
                                    :color    = "validstate[index] ? 'primary' : errorClass"
                                    ref       = "stepheader"
                                >
                                    <!-- Step button -->
                                    <div style="display: flex; align-items: center">
                                        <!-- Step name -->
                                        <div :class="isCurrent(data)?'primary--text':''" >
                                            {{ incidentType.steps[index].name }}
                                        </div>
                                        <c-clipboard-chip
                                            v-if="clipboard(data)"
                                        />
                                        <!-- Step name -->

                                        <div class="primary white--text lm3-chip pa-2 ml-2" v-if="incident.lmVersion === '3.9'">
                                            LM3
                                        </div>

                                        <!-- Step status icon -->
                                        <div>
                                            <v-icon
                                                class="step-icon"
                                                :class="isCurrent(data)?'primary--text':''"
                                            >
                                                {{ stepStatus (data.sequence) }}
                                            </v-icon>
                                        </div>
                                        <!-- Step status icon -->

                                        <!-- incident deleted chip -->
                                        <div v-if="incident.deleted && index === 0" class="deleted-chip ml-2 error white--text" >
                                            Gelöscht
                                        </div>
                                        <!-- incident deleted chip -->

                                        <!-- Bid Overview -->
                                        <div v-if="isTemplate (index,  'bid')" class="v-flex">
                                            <div
                                                v-if   = "isFullMaintenance"
                                                class  = "full-maintenance ml-2 mr-0"
                                                :class = "isCurrent(data)? 'primary white--text' : 'chip-inactive'"
                                            >
                                                Vollwartung
                                            </div>
                                        </div>
                                        <!-- Bid Overview -->

                                        <inc-bid-overview
                                            v-if   = "isBidsNecessary (data)"
                                            :data  = "data"
                                            :color = "isCurrent(data)? 'primary' : 'rgba(0,0,0,.38)'"
                                            class  = "ml-2"
                                        />

                                        <!-- Step attachments -->
                                        <div>
                                            <c-dms-menu-incident
                                                v-if="data.id"
                                                :step-data-id = "data.id"
                                                :category     = "incidentType.steps[index].stepClass"
                                                :step-name    = "incidentType.steps[index].name"
                                            />
                                        </div>
                                        <!-- Step attachments -->

                                        <div v-if = "index === 0 && warranties">
                                            <inc-warranty-button
                                                :warrenties = "warranties"
                                                ref         = "warrantyButton"
                                            />
                                        </div>

                                        <div v-if="index === 0 && unit && modernizationDate" class="primary modernization-chip">
                                            {{ modernizationDate.type }} {{ modernizationDate.date }}
                                        </div>

                                    </div>
                                    <!-- Step button -->
                                    <div
                                        v-if="!loading && data.sequence > maxValid"
                                        class="step-blocked error-background white--text"
                                    >
                                        Bitte {{ maxValid }} abschließen
                                    </div>
                                </v-stepper-step>
                                <v-divider
                                    :key="index"
                                    v-show="data.visible===true"
                                />
                            </template>

                            <!-- Next incident button -->
                            <div
                                class="stepper-next"
                                v-if="incident.next"
                            >
                                <v-tooltip bottom >
                                    <template v-slot:activator="{ on, attrs }">
                                        <a
                                            class  = "stepper-nav-btn"
                                            @click = "onGoto(incident.next.id)"
                                            v-bind = "attrs"
                                            v-on   = "on"
                                        >
                                            <i class="fas fa-chevron-right primary--text"></i>
                                        </a>
                                    </template>
                                    <span>{{ incident.next.name }}</span>
                                </v-tooltip>
                            </div>
                            <!-- Next incident button -->
                        </v-stepper-header>

                        <v-stepper-items>
                            <drop
                                class        = "cut"
                                @drop        = "onDrop"
                                mode         = "cut"
                                accepts-type = "inb-message-selectable"
                            >
                                <v-stepper-content
                                    v-for = "(data, index) in incident.data"
                                    :key  = "`${index}-content`"
                                    :step = "data.sequence"
                                >
                                    <div class="step-panel" v-if="isTemplate(index, 'assessment')">
                                        <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                            <inc-assessment
                                                :incident  = "incident"
                                                :data      = "data"
                                                :bus       = "bus"
                                                :step      = "incidentType.steps[index]"
                                                :index     = "index"
                                                :changes   = "changes"
                                                ref        = "step"
                                                @save      = "onSave"
                                                @postponed = "onPostponed"
                                                @pasted    = "onPasted"
                                                @refresh   = "onRefreshData"
                                                @validated = "onStepValidated"
                                                @attached  = "onAttached"
                                                @journal   = "onCloseDocument"
                                            />
                                        </v-form>
                                    </div>
                                    <div class="step-panel" v-if="isTemplate(index, 'issue')">
                                        <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                            <inc-issue
                                                :incident  = "incident"
                                                :data      = "data"
                                                :step      = "incidentType.steps[index]"
                                                :index     = "index"
                                                :changes   = "changes"
                                                ref        = "step"
                                                @save      = "onSave"
                                                @pasted    = "onPasted"
                                                @refresh   = "onRefreshData"
                                                @validated = "onStepValidated"
                                                @sendmail  = "onSendMail"
                                                @journal   = "onCloseDocument"
                                            />
                                        </v-form>
                                    </div>
                                    <div class="step-panel" v-if="isTemplate(index, 'invoice')">
                                        <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                            <inc-invoice
                                                :incident = "incident"
                                                :sites    = "units"
                                                :data     = "data"
                                                :step     = "incidentType.steps[index]"
                                                :bus      = "bus"
                                                :index    = "index"
                                                ref       = "step"
                                                @refresh  = "onRefreshData"
                                                @save     = "onSave"
                                                @sendmail = "onSendMail"
                                                @sync     = "onSync"
                                                @journal   = "onCloseDocument"
                                            />
                                        </v-form>
                                    </div>
                                    <div class="step-panel" v-if="isTemplate(index, 'bid')">
                                        <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                            <inc-bids
                                                :incident  = "incident"
                                                :data      = "data"
                                                :step      = "incidentType.steps[index]"
                                                :bus       = "bus"
                                                :index     = "index"
                                                :changes   = "changes"
                                                ref        = "step"
                                                @save      = "onSave"
                                                @pasted    = "onPasted"
                                                @validated = "onStepValidated"
                                                @sendmail  = "onSendMail"
                                                @sync      = "onSync"
                                                @journal   = "onCloseDocument"
                                                @refresh   = "onRefreshData"
                                                @notice    = "onInitNotice"
                                            />
                                        </v-form>
                                    </div>
                                    <div class="step-panel" v-if="isTemplate(index, 'mixedinvoice')">
                                        <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                            <inc-mixed-invoice
                                                :incident    = "incident"
                                                :data        = "data"
                                                :step        = "incidentType.steps[index]"
                                                :bus         = "bus"
                                                :index       = "index"
                                                ref          = "step"
                                                @save        = "onSave"
                                                @validated   = "onStepValidated"
                                                @sendmail    = "onSendMail"
                                                @refresh     = "onRefreshData"
                                            />
                                        </v-form>
                                    </div>
                                    <div class="step-panel" v-if="isTemplate(index, 'maintenance')">
                                        <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                            <inc-maintenance
                                                :incident    = "incident"
                                                :data        = "data"
                                                :step        = "incidentType.steps[index]"
                                                :bus         = "bus"
                                                :index       = "index"
                                                ref          = "step"
                                                @save        = "onSave"
                                                @validated   = "onStepValidated"
                                                @sendmail    = "onSendMail"
                                            />
                                        </v-form>
                                    </div>
                                </v-stepper-content>
                            </drop>
                        </v-stepper-items>
                    </v-stepper>
                    <transition name="fade">
                        <div class="app-side-r-buttons" v-if="notice">
                            <c-side-button
                                v-model = "showNotice"
                                :left   = "false"
                                @click  = "onNotice"
                                :title  = "$t('main.inc.notice')" />
                        </div>
                    </transition>
               </div>
            </template>
        </c-app-content>
    </div>
</template>

<script>

import { Drop, }          from "vue-easy-dnd";
//import { getDiff } from 'json-difference'
import Vue                from 'vue'
import Core               from "@/modules/core/service/Core.js";
import Inc                from "@/modules/inc/service/Inc.js";
import Inb                from "@/modules/inb/service/Inb";
import Dms                from "@/modules/dms/common/service/Dms";
import Mail               from "@/modules/inc/mail/service/Mail";
import CSideButton        from "@/modules/core/components/utils/CSideButton";
import IncIssue           from "@/modules/inc/steps/components/issue/IncIssue";
import IncAssessment      from "@/modules/inc/steps/components/assessment/IncAssessment";
import IncInvoice         from "@/modules/inc/steps/components/invoice/IncInvoice";
import IncBids            from "@/modules/inc/steps/components/repair/IncBids";
import IncSideMenu        from "@/modules/inc/steps/components/common/menu/IncSideMenu.vue";
import DIncHistory        from "@/modules/inc/history/DIncHistory";
import CAppContent        from "@/modules/core/components/app/CAppContent";
import CClipboardChip     from "@/modules/inc/steps/components/common/clipboard/CClipboardChip.vue";
import IncMixedInvoice    from "@/modules/inc/steps/components/invoice/IncMixedInvoice";
import CDmsViewerCard     from "@/modules/dms/viewer/CDmsViewerCard.vue";
import IncMaintenance     from "@/modules/inc/steps/components/maintenance/IncMaintenance";
import CDmsMenuIncident   from "@/modules/dms/menu/components/CDmsMenuIncident.vue";
import IncBidOverview     from "@/modules/inc/steps/components/repair/private/IncBidOverview.vue";
import CIncMailEditor     from "@/modules/inc/mail/CIncMailEditor.vue";
import IncWarrantyButton  from "@/modules/inc/warranty/IncWarrantyButton.vue";

export default {
    name: "MIncident",

    components: {
        IncWarrantyButton,
        CIncMailEditor,
        IncBidOverview,
        CDmsMenuIncident,
        IncMaintenance,
        CDmsViewerCard,
        IncMixedInvoice,
        CClipboardChip,
        CAppContent,
        DIncHistory,
        IncBids,
        IncInvoice,
        IncAssessment,
        IncIssue,
        CSideButton,
        IncSideMenu,
        Drop
    },

    data: () => ({
        /**
         * Indicates that an incident is loading.
         */
        loading: false,

        /**
         * the current incident.
         */
        incident: null,

        /**
         * The current incident type containing the processing steps metadata.
         */
        incidentType: null,

        /**
         * Contains the incident data after the last server read request. Used to determine if any data of the incident changed
         */
        incidentFreeze : null,

        /**
         * The units assigned to the current incident.
         */
        units: null,

        /**
         * The sequence number of the current processing step data.
         */
        currentSequence: null,
        currentStep: null,

        /**
         * Key for the stepper component. Used for a force update of the incident data.
         */
        forceUpdate: 0,

        modernizationDate: null,

        saveProcessing: false,

        index      : 0,
        showMail   : false,
        showMailSlide: false,
        mail       : null,
        mailCallback: null,

        notice     : false,
        showNotice : false,
        history    : false,
        bus       : new  Vue(),

        maxValid  : 0,
        validstate: [],
        errorClass: "error-background",

        clipboardEntry: null,
        document: {
            show    : false,
            selected: null,
            callback: null,
        }
     }),

    computed: {
        unit () {
            return this.$store.getters.site;
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        isFullMaintenance () {
            return Inc.isFullMaintenance(this.incident);
        },

        stepName () {
            if (!this.currentSequence) {
                return null;
            }

            const step = this.incident.data.find (d => d.sequence === this.currentSequence);
            if (!step) {
                return null;
            }

            return step.stepName;
        },

        warranties () {
            if (!this.unit) {
                return null;
            }

            if (!this.incident || !this.incident.warrenties) {
                return null;
            }

            const result = this.incident.warrenties.filter (w => w.unit.id === this.unit.id);
            if (!result || result.length === 0) {
                return null;
            }

            return result;
        }
     },

    created() {
        this.validstate.push(false);
        this.validstate.push(false);
        this.validstate.push(false);
        this.validstate.push(false);

        this.$bus.$on(Inb.event.attached,                    this.loadJournal);
        this.$bus.$on(this.$events.refresh,                  this.onRefresh);
        this.$bus.$on(this.$incident.events.context.leave,   this.onContextLeave);
        this.$bus.$on(this.$incident.events.context.entered, this.onContextEnter);
        this.$bus.$on(this.$incident.events.navigate,        this.onEntryNavigation);
        this.$bus.$on(this.$incident.events.unit.remove,     this.onRemoveUnit);
        this.$bus.$on(this.$events.mail,                     this.onExternalMail);
        this.$bus.$on(Dms.event.document.selected,           this.onDocument);
        this.$bus.$on(Dms.event.document.refresh,            this.onDocumentRefresh);
    },

    beforeDestroy() {
        this.$bus.$off(Inb.event.attached,                    this.loadJournal);
        this.$bus.$off(this.$events.refresh,                  this.onRefresh);
        this.$bus.$off(this.$incident.events.context.leave,   this.onContextLeave);
        this.$bus.$off(this.$incident.events.context.entered, this.onContextEnter);
        this.$bus.$off(this.$incident.events.navigate,        this.onEntryNavigation);
        this.$bus.$off(this.$incident.events.unit.remove,     this.onRemoveUnit);
        this.$bus.$off(this.$events.mail,                     this.onExternalMail);
        this.$bus.$off(Dms.event.document.selected,           this.onDocument);
        this.$bus.$off(Dms.event.document.refresh,            this.onDocumentRefresh);
    },

    watch: {
        validstate: {
            deep: true,
            handler: function () {
                this.onStepValidated();
            }
        },

        unit () {
            this.modernization ();
        }
    },

    methods: {
        /**
         * Loads the incident with the given ID and all related data.
         * @param incidentId the incident ID.
         * @param unitId the required context
         */
        load (incidentId, unitId, stepId, event) {
            this.loading = true;
            Core.loading(this, true, this.$t("inc.loading.load"));
            this.$store.dispatch('getIncidentById', incidentId)
                .then (() => {
                    this.initialize(incidentId, unitId, stepId, event);
                })
                .catch((error) => {
                    Core.log(error)
                    Core.loading(this, false);
                    Core.message.hint(this, "Ereignis konnte nicht geladen werden.", true)
                });
        },

        initialize (incidentId, unitId, stepId, event) {
            this.incident        = this.$store.getters.incident;
            this.incidentFreeze  = JSON.stringify(this.copyIncident());
            this.incidentType    = this.$store.getters.incidenttypes.find (type => this.incident.typeId === type.id);

            let stepIndex = 0;
            if (stepId) {
                const index = this.incident.data.findIndex (stepData => stepData.stepName === stepId);
                if (index >= 0) {
                    stepIndex = index;
                }
            }

            this.currentSequence = this.incident.data[stepIndex].sequence;
            this.units           = this.incident.sites;
            this.mail            = null;
            this.showMailSlide   = false,
            this.forceUpdate ++;

            this.notice = this.isTemplate(0, 'bid') || this.isTemplate(0, 'mninvoice');
            this.publishContext (unitId ? unitId : this.units[0].id, this.incident.id, "selected");

            this.$nextTick(() => {
                this.currentStep = this.step();
                this.$bus.$emit(this.$incident.events.context.stepChanged, 0);

                if (event && event.id === 'standstill' && this.currentStep._unitDownCreate) {
                    this.currentStep._unitDownCreate (event);
                }

                if (event && this.currentStep._unitDownResolved) {
                    switch (event.id) {
                        case "unitDownResolved":
                            this.currentStep._unitDownResolved (event);
                            break;
                    }
                }

                this.modernization ();
            });

            this.loadJournal(incidentId).then(() => {
                this.loading = false;
                this.onStepValidated();

                Core.loading(this, false);
            });
        },

        modernization () {
            if (!this.unit) {
                this.modernizationDate = null;
                return;
            }

            Inc.modernization.findByUnit(this.unit.id).then (modernizationDate => {
                if (modernizationDate && this.incident.id === modernizationDate.incidentId) {
                    this.modernizationDate = null;
                    return;
                }

                if (modernizationDate.type) {
                    if (!modernizationDate.date) {
                        this.modernizationDate = {
                            type: modernizationDate.type,
                            date: "in Bearbeitung"
                        };
                    } else {
                        this.modernizationDate = {
                            type: modernizationDate.type,
                            date: Core.format.date.display(modernizationDate.date)
                        };
                    }
                } else if (this.unit && this.unit.specification && this.unit.specification.yearOfRebuild) {
                    this.modernizationDate = {
                        type: "Ersatzanlage",
                        date: this.unit.specification.yearOfRebuild
                    }
                } else {
                    this.modernizationDate = null;
                }
            })
        },

        /**
         * Loads the journal for the incident with the given ID.
         */
        loadJournal () {
            if (this.incident.id === null) {
                return;
            }

            return this.$store.dispatch("findJournalByIncident", {
                incidentId   : this.incident.id,
                ignoreDeleted: false
            });
        },

        /**
         * Initialized event, which indicates that the application context is initialized and all enumaration data
         * is availible.
         */
        onInitialized () {
            this.load(this.$route.params.id, this.$route.params.unitId, this.$route.params.stepId, this.$route.params.event);
        },

        /**
         *
         * @param params
         */
        onRefresh (params) {
            if (!params) {
                this.load(this.incident.id);
                return;
            }

            this.load(params.id, params.unitId);
        },



        /**
         * The user navigates tu another unit.
         */
        onEntryNavigation () {
            this.onSave();
        },

        /**
         *
         */
        onNotice () {
            this.bus.$emit(Inc.events.notice, this.showNotice);
        },

        onInitNotice (value) {
            this.showNotice = value;
        },

        onStepChanged () {
            this.onSave();
            this.index = Inc.step.index(this.currentSequence);
            this.currentStep = this.step();
            this.notice = this.currentStep.$options.name === 'IncBids';
            this.refreshClipboard();

            if (this.currentStep.display ) {
                this.currentStep.display ();
            }

            this.validate();
            this.errorState();

            this.$bus.$emit(this.$incident.events.context.stepChanged, this.index);
        },

        /**
         * Drop event, which indicates that a new unit should be assigned to the incident.
         * @param event the event that contains the unit to be assigned.
         */
        onDrop (event) {
            if (!event.data) {
                return;
            }

            const id = event.data.id;
            if (this.units.find(unit => unit.id === id)) {
                return;
            }

            Inc.addUnit(this.incident.id, event.data.id).then ((data) => {
                this.showIncident (data, () => {
                    this.currentSequence = data.data[0].sequence;
                    this.publishContext(event.data.id, this.incident.id);
                    this.$nextTick(() => {
                        const steps = this.$refs.step;
                        steps.forEach ((step) => {
                            step._setContext (event.data)
                            step._validate ()
                        });
   //                     this.onSave();
                    });
                });
            });
        },

        /**
         * Opens a dialog to confirm to remove a unit form the incident.
         * @param unit the unit to remove.
         */
        onRemoveUnit (unit) {
            Core.message.confirm(
                this,
                this.$t("inc.unit.remove.query"),
                this.$t("inc.unit.remove.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }
                    const index = this.units.findIndex(u => u.id === unit.id);
                    if (index < 0) {
                        return;
                    }

                    Inc.removeUnit(this.incident.id, unit.id).then ((data) => {
                        const currentUnit = this.$store.getters.context.site;
                        if (unit.id === currentUnit) {
                            //
                            // The current unit was removed. In this case we switch to the first unit ...
                            //
                            let newUnit = this.units[0];
                            if (newUnit.id === unit.id) {
                                // the unit to remove is the first unit and visible
                                newUnit = this.units[1];
                            }


                            this.$nextTick(() => {
                                this.showIncident (data, () => {
                                    const steps = this.$refs.step;
                                    steps.forEach ((step) => {
                                        step._setContext (newUnit);
                                    })
                                    this.publishContext(newUnit.id, this.incident.id);
                                });
                            });
                        } else {
                            //
                            // An invisible unit was removed. Refresh the current view ...
                            //
                            this.$nextTick(() => {
                                this.showIncident (data, (() => {
                                }));
                            });
                        }
                    });
            })
        },

        onPasted (event) {
            this.$bus.$emit(Inc.events.journal);
            this.showIncident (event.data, () => {
                this.publishContext(event.unit.id, this.incident.id);
                this.$nextTick(() => {
                    const steps = this.$refs.step;
                    steps.forEach ((step) => {
                        step._setContext (event.unit)
                        step._validate ()
                        this.$bus.$emit(Vue.prototype.$events.refreshdocuments);
                    });
                });
            });
        },

        /**
         * A message was attached to a processing step.
         *
         */
        onRefreshData (message) {
            let unit = this.$store.getters.site;
            if (message && message.sites && message.sites.length === 1) {
                unit = message.sites[0]
            }

            this.$bus.$emit(Inc.events.journal);
            this.$store.dispatch('getIncidentById', this.incident.id).then(() => {
                this.showIncident (this.$store.getters.incident, () => {
                    this.publishContext(unit.id, this.incident.id);
                    this.$nextTick(() => {
                        const steps = this.$refs.step;
                        steps.forEach ((step) => {
                            step._setContext (unit)
                            step._validate ()
                        });
                    });
                });
            })
        },

        /**
         * Event, that's indicated that a new unit was selected or inserted by the user.
         */
        onContextLeave (callback) {
            const steps = this.$refs.step;
            if (!steps) {
                callback ();
                return;
            }

            steps.forEach ((step) => {
                step._validate ()
            });

            this.onSave(() => {
                callback ();
            });
        },

        onContextEnter (context) {
            const steps = this.$refs.step;
            steps.forEach ((step) => {
                step._setContext (context.unit)
            })

            this.$nextTick().then (() => {
                const currentData = this.incident.data.find (d => d.sequence === this.currentSequence);
                if (currentData) {
                    const visible = currentData.visible;

                    if (!visible) {
                        this.currentSequence = "1a"
                    }
                }

                steps.forEach ((step) => {
                    step._validate ();
                });

                this.refreshClipboard();
            })
        },

        onAttached (event) {
            this.onSave(() => {
                this.showIncident (event.incident, () => {
                    this.publishContext(event.unit.id, event.incident.id);
                    this.$nextTick(() => {
                        const steps = this.$refs.step;
                        steps.forEach ((step) => {
                            step._setContext (event.unit)
                            step._validate ()
                        });
                        this.onSave();
                    });
                });
            });
        },

        onClipboard () {
            this.onSave(() => {
                const unit = this.$store.getters.site;
                Inc.clipboard.add(this.incident.id, unit).then((data) => {
                    this.$nextTick(() => {
                        this.showIncident (data, () => {
                            Core.message.hint(this, this.$t("clipboard.add.success"));
                        });
                    });
                });
            });
        },

        onClipboardRemove (entry) {
            const unit = this.$store.getters.site;
            Inc.clipboard.remove(entry, unit).then ((data) => {
                this.$nextTick(() => {
                    this.showIncident (data, () => {
                        Core.message.hint(this, this.$t("clipboard.remove.success"));
                    });
                });
            });
        },

        /**
         * Adopts a value from another step data panel.
         * @param event event containing the index of the target step data and the name/value pair to adapt.
         */
        onSync (event) {
            if (event.index < 0) {
                return;
            }

            const stepdata = this.incident.data[event.index];
            if (stepdata) {
                stepdata[event.name] = event.value;
            }
        },

        onKeyup (event) {
            if (event.ctrlKey===true && event.code==="KeyS") {
                this.onSave();
            }

            if (event.ctrlKey===true && event.code==="KeyF") {
                this.$bus.$emit(this.$events.opensearch);
            }
        },

        onSave (success) {
            if (this.saveProcessing) {
                Core.message.warning(this, "Speichern noch nicht abgeschlossen!")
                return;
            }

            this.saveProcessing = true;
            const step = this.currentStep; // this.step();
            if (!step) {
                this.saveProcessing = false;
                return;
            }

            step.validate ().then(() => {
                this.onStepValidated ();
                const incident = this.changes();
                if (!incident) {
                    Core.log("no changes")
                    this.saveProcessing = false;
                    if (success) success ();
                    return;
                }

                Core.log("**** STORE")
                Core.log(this.incident)
                Inc.save(this, incident, (data) => {
                 //   this.freeze();
                    this.$emit(this.$incident.events.save)
                    this.showIncident (data, success);
                    this.saveProcessing = false;
                    Core.log("save done")
                }, error => {
                    const errorId = error.id;
                    if (errorId && errorId !== "inc.incident.reference.exists") {
                        const incidentId = error.parameter[0];
                        this.saveProcessing = false;
                        Core.message.popup(this, errorId, ["Prüfungskosten durch ZÜS", incidentId], { parameter: [incidentId] });
                    }
                });
            });
        },

        showIncident (data, success) {
            this.$store.dispatch("updateIncident", data).then (() => {
                console.log("INCIDENT UPDATED", this.$store.getters.incident)
                this.incident = this.$store.getters.incident;
                this.units    = this.incident.sites;

                this.$nextTick(()=> {

                    // CHANGE !!!!
                    const steps = this.$refs.step;
                    steps.forEach((step) => {
                        step._forceUpdate ();
                    });

                    this.incidentFreeze = JSON.stringify(this.copyIncident());
                    this.$nextTick(() => {
                        this.refreshClipboard();
                    });

                    if (success) success ();
                })

            });
        },

        onHistory () {
            this.history = true;
        },

        onDelete () {
            Inc.delete(this.incident.id, () => {
                this.refreshClipboard();
                Core.message.hint(this, "Das Ereignis wurde gelöscht");
                this.incident.deleted = true;
            });
        },

        onUnDelete () {
            Inc.undelete(this.incident.id, null,() => {
                Core.message.hint(this, "Die Löschung des Ereignis wurde zurückgesetzt");
                this.incident.deleted = false;
            });
        },

        /**
         * The currently displayed processing step has been validated. Now calculate the processing step up to which
         * all previous steps have also been successfully validated.
         */
        onStepValidated () {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.maxValid = "1a"

            if (!this.incident ) {
                return;
            }

            const steps =  this.$refs.step;
            for (let index = 0; index < steps.length; index ++) {
                const stepMeta = this.incidentType.steps[index];
                const stepFile = this.incident.data[index];

                if (!stepFile || !stepFile.visible || stepFile.invoice) {
                    continue;
                }

                this.maxValid = stepFile.sequence;
                if (!this.validstate[index]) {
                    if (stepMeta["stepClass"] === "invoiceService" && index > 0 && !this.validstate[index-1]) {
                        break;
                    }

                    if (stepMeta["stepClass"] !== "invoiceService") {
                        break;
                    }
                }

                if (stepMeta["stepClass"] !== "invoiceService") {
                    const step = this.$refs[stepFile.sequence][0].$children[0];
                    if (!step._isTerminated ()) {
                        break;
                    }
                }
            }

            this.errorState();
            this.loading = false;
        },

        onPostponed () {
            this.onSave(() => {
                this.loadJournal(this.incident.id);
            })
        },

        onChange () {
            this.onRefresh({
                id: this.incident.id
            });
        },

        onGoto (incidentId) {
            Inc.goto(this, incidentId);
        },

        onMail () {
            if (this.showMailSlide) {
                return;
            }

            this.mail = null;
            this.showMailSlide    = false;
            this.onMailToggle();
        },

        onMailToggle () {
            if (!this.mail) {
                if (!this.showMailSlide) {
                    this.onSave(() => {
                        const step = this.step();
                        step.getMail().then((mail) => {
                            const unitId = this.$store.getters.context.site;
                            this.mail = mail;
                            this.mail.unitId = unitId;
                            this.showMailSlide = !this.showMailSlide
                        });
                    });
                } else {
                    this.showMailSlide = false;
                }
            } else {
                this.showMailSlide = !this.showMailSlide;
            }
        },

        onSendMail (mail) {
            this.onSave();

            const unitId       = this.$store.getters.context.site;
            this.mail          = mail;
            this.mail.unitId   = unitId;
            this.showMailSlide = true;
        },

        onSended () {
            this.showMailSlide = false;
            const stepData = this.incident.data[this.index];
            if (!stepData) {
                return;
            }

            Inc.document.byStep(stepData.id, {
                bidId : null,
                unitId: null,
            }, (data) => {
                stepData.documents = data;
            })
        },

        onExternalMail (contact) {
            if (!this.incident) {
                return;
            }

            const stepData = this.incident.data[this.index];
            if (!stepData) {
                return;
            }

            const stepId = stepData.stepId;
            if (!stepId) {
                return;
            }

            Mail.mail(contact.company.id, this.incident, this.index, stepId, { id: -1 }, [ contact ]).then(mail => {
                this.onSendMail(mail);
            });
        },

        onDocument (event) {
            this.document.show = true;
            this.document.selected = event.document;
            this.document.callback = event.callback;
        },

        onDocumentRefresh (event) {
            this.$store.dispatch("updateDocuments", event).then(() => {
                this.$bus.$emit(Vue.prototype.$events.refreshdocuments);
            });
        },

        onCloseDocument () {
            this.document.show = false;
            this.document.selected = null;
            this.document.callback = null;
        },

        onAssigned (event) {
            this.document.callback (event);
            this.$bus.$emit(Vue.prototype.$events.refreshdocuments);
        },

        /**
         * Publishes the global context (current site and optional current incident).
         *
         * @param unitId
         * @param incidentId
         */
        publishContext (unitId, incidentId) {
            this.$bus.$emit(this.$incident.events.context.leave, () => {
                this.$store.dispatch("setContext", {
                    incident: incidentId,
                    site    : unitId
                }).then(() => {
                    const unit = this.units.find (s => s.id === unitId);
                    this.index = Inc.step.index(this.currentSequence);
                    this.$bus.$emit(this.$incident.events.context.entered, {
                        unit : unit,
                        index: this.index
                    });
                });
            })
        },

        validate () {
            const step = this.step();
            if (!step) {
                return;
            }

            step.validate ();
        },

        currentStatus () {
            if (this.currentStep == null) {
                return null;
            }

            return this.currentStep._status()
        },

        freeze () {
            const steps = this.$refs.step;
            steps.forEach((step) => {
                step._forceUpdate ();
            });
        },

        /**
         * Checks if bid processing is necessary.
         * @param data the current repair data.
         * @return true, if bid processing is necessary.
         */
        isBidsNecessary (data) {
            return Inc.isBidsNecessary(this.incident, data);
        },

        isTemplate (index, name) {
            if (!this.incidentType) {
                return false;
            }

            return this.incidentType.steps[index].template.name === name;
        },

        stepStatus (sequence) {
            if (!this.$refs[sequence] || !this.$refs[sequence][0] || !this.$refs[sequence][0].$children) {
                return null;
            }

            const step = this.$refs[sequence][0].$children[0];
            if (!step) {
                return null;
            }

            const status = step._status ();
            if (status == null || status.font === null) {
                return null;
            }

            return status.font + " fa-" + status.symbol;
        },

        copyIncident () {
            return {
                id           : this.incident.id,
                version      : this.incident.version,
                deleted      : this.incident.deleted,
                sites        : this.incident.sites,
                externalId   : this.incident.externalId,
                offerDate    : this.incident.offerDate,
                siteDownBegin: this.incident.siteDownBegin,
                siteDownEnd  : this.incident.siteDownEnd,
                siteDown     : this.incident.siteDown,
                responsible  : this.incident.responsible,
                data         : []
            };
        },

        async errorState () {
            if (!this.$refs.stepheader) {
                return;
            }

            await this.$nextTick(() => {
                for (let index = 0; index < this.validstate.length; index++) {
                    const step = this.$refs.stepheader[index];
                    if (step) {
                        if (this.validstate[index]) {
                            step.$el.children[0].classList.remove(this.errorClass);
                        } else {
                            step.$el.children[0].classList.add(this.errorClass);
                        }
                    }
                }
            });
        },

        /**
         * Checks which data has changed and returns the modified incident and the modified processing step data.
         * Data that has not been changed will not be returned.
         * @return the modified incident and step data.
         */
        changes () {
            let modified = false;

            const incident = this.copyIncident();
            const steps =  this.$refs.step;
            steps.forEach(step => {
                const json = JSON.stringify(step.data)

 //               if (step.data && step.freeze)
 //               console.log("**** changes ", getDiff (step.data, JSON.parse(step.freeze)))

                if (step.freeze !== json) {
                    incident.data.push (step.data);
                    modified = true;
                }
            });

            if (this.incidentFreeze !== JSON.stringify(this.copyIncident())) {
                modified = true;
            }

            return modified ? incident : null;
        },

        /**
         * Returns the component of the current step.
         * @return the component of the current step.
         */
        step () {
            if (!this.$refs[this.currentSequence]) {
                return null;
            }
             return this.$refs[this.currentSequence][0].$children[0];
        },

        /**
         * Determines if the given data belongs to the current processing step.
         * @param data the processing step data to check.
         * @return true, if the given data belongs to the current processing step.
         */
        isCurrent (data) {
            return this.currentSequence === data.sequence;
        },

        clipboardUnit (data, unit) {
            const entry = data.collection.find(e => e.unit.id === unit.id);
            if (!entry) {
                return false;
            }

            return entry.clipboardEntry;
        },

        clipboard (data) {
            if (!this.isCurrent(data)) {
                return false;
            }

            if (!this.$refs[data.sequence] || !this.$refs[data.sequence][0]) {
                return false;
            }

            const step = this.$refs[data.sequence][0].$children[0];
            return step._clipboardEntry ? step._clipboardEntry () : false;
        },

        refreshClipboard () {
            this.clipboardEntry = this.currentStep._clipboardEntry();
            const units = this.incident.sites;
            if (!units || units.length === 0) {
                this.$store.dispatch("refreshClipboard", null);
                return;
            }

            this.$store.dispatch("refreshClipboard", units[0].customer.id);
        },
    }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

.step-incident-id {
    position: absolute;
    left: -42px;
    font-size: 9pt;
    top: 46px;
    width: 100px;
    text-align: right;
    z-index: 2;
}

.step-panel {
    width: 100%;
    display: flex;
}

.step-icon  {
    font-size: 12pt!important;
    padding-left: 10px;
}

.inc-stepper{
    padding-left: 0;
}

::v-deep .v-stepper, .v-stepper__header {
    box-shadow: none!important;
}

::v-deep .v-stepper__content {
    padding: 0;
}

::v-deep .v-stepper__header {
    height: 64px;
  padding-bottom: 6px;
}

::v-deep .v-stepper__header .v-stepper__step {
    padding-top: 0;
    padding-bottom: 0;
}

::v-deep .v-stepper__header .v-stepper__step:first-child {
    padding-left: 0;
}

::v-deep .v-stepper__header .v-stepper__step:nth-last-child(2) {
    padding-right: 0!important;
}

::v-deep .v-stepper__step__step {
    height: 32px;
    width: 32px;
    font-size: 12pt;
    font-weight: 400;
}

::v-deep .v-btn:before {
    background-color: transparent;
}

.stepper-nav-btn {
    padding-left: 10px!important;
    padding-right: 10px!important;
}
.stepper-prev {
    position: fixed;
    left: 35px;
    margin-top: 20px;
}

.stepper-prev i,
.stepper-next i {
    font-size: 30px;
}

.stepper-next {
    position: fixed;
    right: 15px;
    margin-top: 20px;
}

.step-blocked {
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 2px;
    position: absolute;
    top: 37px;
    margin-top: 3px
}

.full-maintenance {
    height: 29px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    font-size: 10pt;
    font-weight: 500;
    padding-top: 7px;
}

.chip-inactive {
    background-color: rgba(0,0,0,.38);
    color: white;
}

.deleted-chip {
    height: 28px;
    width: 90px;
    border-radius: 14px;
    text-align: center;
    padding-top: 5px;
}

.lm3-chip {
    width: 80px;
    height: 28px;
    border-radius: 14px;
    line-height: 12px;
    text-align: center;
    font-size: 15px;
}

.modernization-chip {
    color: white;
    border-radius: 14px;
    line-height: 12px;
    height: 28px;
    text-align: center;
    font-size: 15px;
    padding-top: 8px;
    padding-left: 12px;
    padding-right: 12px;
}

</style>